import { Turbo } from "@hotwired/turbo-rails";

/**
 * カスタムTurbo Streamアクション: set_dataset_attribute
 *
 * ターゲット要素のdata-*属性を更新する。
 * Stimulus valuesのdata属性を更新すると、ValueChangedコールバックが自動的に発火する。
 *
 * 使用例（turbo_stream.erb）:
 *   <turbo-stream action="set_dataset_attribute" target="harvest_warehouse"
 *     attribute="harvest-warehouse-available-balance-value" value="5000">
 *   </turbo-stream>
 */
Turbo.StreamActions.set_dataset_attribute = function () {
  const attribute = this.getAttribute("attribute");
  const value = this.getAttribute("value");

  this.targetElements.forEach((element) => {
    element.setAttribute(`data-${attribute}`, value);
  });
};
